export default {
  primary: '#21286c',
  warn: '#f34242',
  disabled: '#ddd',
  bodyColor: 'whitesmoke',
  white: '#fff',
  subText: '#777',
};
